import React, { FC } from 'react';
import { useWsUsers } from 'src/models/workspace/hooks';
import { CommentParentType } from 'src/models/comments/types';
import { BlockTitle, Comments } from 'src/shared';
import { useTranslation } from 'react-i18next';
import { TASK_EDITOR_ICON_MAPPER } from 'src/models/bids/BidTask/mappers';
import { useBidding } from 'src/models/bids/BidFull/hooks';
import { useTask } from 'src/models/bids/BidTask/hooks';
import styles from './index.module.scss';

export const BidTaskComments: FC = () => {
  const { t } = useTranslation();
  const { data: task } = useTask();
  const { data } = useBidding();
  const users = useWsUsers(data?.workspaceId);

  return (
    <>
      {task && (
        <div className={styles.comments}>
          <BlockTitle title={t('Comments.comments')} icon={TASK_EDITOR_ICON_MAPPER['comments']} />
          <Comments
            comments={task.comments}
            parentId={task.id}
            parentType={CommentParentType.BidQuestion}
            mode={'multiple'}
            users={users}
          />
        </div>
      )}
    </>
  );
};

export default BidTaskComments;
